import { default as indexC05GXedQnIMeta } from "/codebuild/output/src2504466115/src/src/pages/[companySlug]/faq/[id]/index.vue?macro=true";
import { default as index6UvSgBc8mdMeta } from "/codebuild/output/src2504466115/src/src/pages/[companySlug]/important-news/index.vue?macro=true";
import { default as indexWXzGRWB6GGMeta } from "/codebuild/output/src2504466115/src/src/pages/[companySlug]/index.vue?macro=true";
import { default as index0jGyv6eRYRMeta } from "/codebuild/output/src2504466115/src/src/pages/[companySlug]/news/[id]/index.vue?macro=true";
import { default as indexpkMeHYc6HfMeta } from "/codebuild/output/src2504466115/src/src/pages/[companySlug]/news/index.vue?macro=true";
import { default as indexDKasmv3EVpMeta } from "/codebuild/output/src2504466115/src/src/pages/[companySlug]/preview/faq/index.vue?macro=true";
import { default as indexXtqC9E9kL9Meta } from "/codebuild/output/src2504466115/src/src/pages/[companySlug]/preview/news/index.vue?macro=true";
export default [
  {
    name: "companySlug-faq-id",
    path: "/:companySlug()/faq/:id()",
    component: () => import("/codebuild/output/src2504466115/src/src/pages/[companySlug]/faq/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "companySlug-important-news",
    path: "/:companySlug()/important-news",
    component: () => import("/codebuild/output/src2504466115/src/src/pages/[companySlug]/important-news/index.vue").then(m => m.default || m)
  },
  {
    name: "companySlug",
    path: "/:companySlug()",
    component: () => import("/codebuild/output/src2504466115/src/src/pages/[companySlug]/index.vue").then(m => m.default || m)
  },
  {
    name: "companySlug-news-id",
    path: "/:companySlug()/news/:id()",
    component: () => import("/codebuild/output/src2504466115/src/src/pages/[companySlug]/news/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "companySlug-news",
    path: "/:companySlug()/news",
    component: () => import("/codebuild/output/src2504466115/src/src/pages/[companySlug]/news/index.vue").then(m => m.default || m)
  },
  {
    name: "companySlug-preview-faq",
    path: "/:companySlug()/preview/faq",
    component: () => import("/codebuild/output/src2504466115/src/src/pages/[companySlug]/preview/faq/index.vue").then(m => m.default || m)
  },
  {
    name: "companySlug-preview-news",
    path: "/:companySlug()/preview/news",
    component: () => import("/codebuild/output/src2504466115/src/src/pages/[companySlug]/preview/news/index.vue").then(m => m.default || m)
  }
]